<template>
  <div class="partners-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入关键词查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="600"
            :mask-closable="false"
            :styles="styles">
      <Form :model="agents"
            :label-width="60"
            ref="agentsValidate"
            :rules="agentsValidate">
        <FormItem label="手机号"
                  label-position="top">{{ agents.phone }}</FormItem>
        <FormItem label="姓名"
                  label-position="top"
                  prop="name">
          <Input v-model="agents.name"></Input>
        </FormItem>
        <FormItem label="简介"
                  prop="describe">
          <Input v-model="agents.describe"
                 type="textarea"
                 :rows="4"
                 placeholder="简介..."></Input>
        </FormItem>
        <FormItem label="身份证正面照"
                  prop="imageface">
          <upload-thumb v-model="agents.imageface"
                        ref="imagefaceuploadthumb"
                        :defaultList="imagefacethumblist"
                        :autoCropWidth="100"
                        :autoCropHeight="100"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="身份证反面照"
                  prop="imageback">
          <upload-thumb v-model="agents.imageback"
                        ref="imagebackuploadthumb"
                        :defaultList="imagebackthumblist"
                        :autoCropWidth="100"
                        :autoCropHeight="100"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="统一社会信用代码"
                  label-position="top"
                  prop="company_code">
          <Input v-model="agents.company_code"></Input>
        </FormItem>
        <FormItem label="营业执照照片"
                  prop="company_photo">
          <upload-thumb v-model="agents.company_photo"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="154"
                        :autoCropHeight="154"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:154*154,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="审核状态"
                  label-position="top">
          <Select v-model="agents.status"
                  clearable
                  filterable
                  placeholder="审核状态">
            <Option :value="0"
                    :key="0">待审核</Option>
            <Option :value="1"
                    :key="1">通过审核</Option>
            <Option :value="2"
                    :key="2">未通过审核</Option>
          </Select>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="editagent('agentsValidate')">提交</Button>
      </div>
    </Drawer>
    <Modal v-model="shenheStatus"
           title="审核"
           @on-ok="updateStatus()"
           :loading="loading">
      <Select v-model="reviewStatus"
              clearable
              filterable
              placeholder="审核状态">
        <Option :value="0"
                :key="0">待审核</Option>
        <Option :value="1"
                :key="1">通过审核</Option>
        <Option :value="2"
                :key="2">未通过审核</Option>
      </Select>
    </Modal>

    <Modal v-model="biliStatus"
           title="比例设置"
           @on-ok="updateBili()"
           :loading="loading">
      <span style="color:red;">*一级分销商分销收入从平台服务费中扣除</span>
      <Form :model="biliModel"
            :label-width="60">
        <FormItem label="云支付比例："
                  label-position="top">
          <Input v-model="biliModel.underline_fx"
                 placeholder="输入百分数，例如10%"></Input>
        </FormItem>
        <FormItem label="商城比例:"
                  label-position="top">
          <Input v-model="biliModel.on_fx"
                 placeholder="输入百分数，例如10%"></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";
export default {
  name: "partners-list",
  data () {
    return {
      //抽屉参数
      value3: false,
      isable: false,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      biliModel: { on_fx: null, underline_fx: null },
      isClear: false,
      loading: true,
      dataloading: true,
      imagefacethumblist: [], // 身份证是正面
      imagebackthumblist: [], // 身份证反面
      thumblist: [], // 营业执照
      cates: [],
      cateList: [],
      skillList: [],
      intangibleList: [],
      title: "",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "用户",
          key: "name",
          width: 350,
          render: (h, params) => {
            var a = "";
            if (
              params.row.userdata != null &&
              params.row.userdata.username != null
            )
              a = params.row.userdata.username;
            var b = "";
            if (params.row.company != null) b = params.row.company;
            var c = "";
            if (
              params.row.userdata != null &&
              params.row.userdata.nickname != null
            )
              c = params.row.userdata.nickname;
            var d = "";
            if (params.row.userdata != null && params.row.userdata.uuid != null)
              d = params.row.userdata.uuid;
            var e = "";
            if (params.row.user != null && params.row.user.openid != null)
              e = params.row.user.openid;
            var f = "";
            if (
              params.row.user != null &&
              params.row.user.map_mp_openid != null
            )
              f = params.row.user.map_mp_openid;
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "用户名：" + a
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "名称：" + b
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "昵称：" + c
              ),
              h(
                "p",
                {
                  style: {
                    color: "#337ab7"
                  }
                },
                "用户ID：" + d
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "微信ID：" + e
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "小程序ID：" + f
              )
            ]);
          }
        },
        {
          title: "电话",
          key: "userdata.username",
          minWidth: 150,
          render: (h, params) => {
            var s = "";
            if (
              params.row.userdata != null &&
              params.row.userdata.username != null
            )
              s = params.row.userdata.username;
            return h("span", s);
          }
        },
        // {
        //     title: '提成',
        //     key: 'describe',
        //     width:150,
        //     render:(h,params)=>{
        //         var s  = "";
        //         if(params.row.underline_fx!=null )
        //             s = params.row.underline_fx;
        //         return h('span',s);
        //     }
        // },
        {
          title: "注册时间",
          key: "created_at",
          width: 150
        },
        {
          title: "操作",
          key: "action",
          width: 400,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            var s = this.status == 1 ? "none" : "inline-block";
            var m = this.status != 1 ? "none" : "inline-block";
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display: s
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showShenhe(
                        params.row.partner_uuid,
                        params.row.status
                      );
                    }
                  }
                },
                "审核"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.partner_uuid);
                    }
                  }
                },
                "编辑"
              ),
              // h('Button', {
              //     style:{
              //         marginRight:'8px',
              //         display:m
              //     },
              //     props: {
              //         type: 'warning',
              //         size: 'small'
              //     },
              //     on: {
              //         click: () => {
              //             this.goagentlist(params.row.partner_uuid)
              //         }
              //     }
              // }, '代理商户'),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display: m
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.gotradesmanlist(params.row.partner_uuid);
                    }
                  }
                },
                "商户"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display: m
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.gotcrecord(params.row.partner_uuid);
                    }
                  }
                },
                "提成记录"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display: m
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showbili(params.row.partner_uuid);
                    }
                  }
                },
                "提成比例设置"
              )
              // h('Button', {
              //     style:{
              //         marginRight:'8px',
              //         display:m
              //     },
              //     props: {
              //         type: 'error',
              //         size: 'small'
              //     },
              //     on: {
              //         click: () => {
              //             this.remove(params.row.uuid,params.row.id)
              //         }
              //     }
              // }, '删除')
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      agents: {
        id: null,
        nickname: "",
        phone: "",
        name: "",
        status: "0",
        describe: "",
        imageface: "",
        imageback: "",
        company_photo: ""
      },
      agentsValidate: {
        name: [{ required: true, message: "姓名必须填写", trigger: "change" }],
        describe: [
          { required: true, message: "简介必须填写", trigger: "change" }
        ],
        imageface: [
          { required: true, message: "请上传身份证正面", trigger: "change" }
        ],
        imageback: [
          { required: true, message: "请上传身份证反面", trigger: "change" }
        ],
        company_photo: [
          { required: true, message: "请上传营业执照", trigger: "change" }
        ]
      },
      status: 1,
      shenheStatus: false,
      shenheId: 0,
      reviewStatus: 0,
      biliStatus: false
    };
  },
  created: function () {
    this.status = this.$route.params.status;
    this.getTableList();
  },
  components: {
    UploadThumb,
    // EditorBar,
    uploadthumbTwo
  },
  watch: {
    "$route.params.status": function (curVal, oldVal) {
      if (curVal) {
        this.status = curVal;
        this.getTableList();
      }
    }
  },
  methods: {
    getTableList: function () {
      this.$api.partners
        .list({
          page: this.pages.page,
          size: this.pages.size,
          status: this.status
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    getCateList () {
      this.$api.partners.cate({ page: 1, size: 1000 }).then(res => {
        if (res.code == 200) {
          this.cateList = res.result.list;
        }
      });
    },
    getSkillList () {
      this.$api.partners.skill({ page: 1, size: 1000 }).then(res => {
        if (res.code == 200) {
          this.skillList = res.result.list;
          // console.log(this.skillList)
        }
      });
    },
    getItemList () {
      this.$api.intangibleItem.list({ page: 1, size: 200 }).then(res => {
        if (res.code == 200) {
          this.intangibleList = res.result.list;
        }
      });
    },
    showShenhe (uuid, status) {
      this.shenheStatus = true;
      this.shenheId = uuid;
      this.reviewStatus = status;
    },
    showbili (uuid) {
      this.biliStatus = true;
      this.shenheId = uuid;
      this.$api.partners.detail({ id: uuid }).then(res => {
        if (res.code == 200) {
          var s = res.result;
          this.biliModel.on_fx = s.on_fx;
          this.biliModel.underline_fx = s.underline_fx;
        } else {
          this.$Message.success(res.msg);
        }
      });
    },
    updateBili () {
      this.$api.partners
        .bili({
          uuid: this.shenheId,
          on_fx: this.biliModel.on_fx,
          underline_fx: this.biliModel.underline_fx
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.renderTable(1);
            this.biliStatus = false;
          } else {
            this.$Message.success(res.msg);
          }
        });
    },
    updateStatus () {
      this.$api.partners
        .reviewStatus({ uuid: this.shenheId, status: this.reviewStatus })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.renderTable(1);
            this.shenheStatus = false;
          } else {
            this.$Message.success(res.msg);
          }
        });
    },
    // 详情
    detail (index) {
      this.agents = {
        id: null,
        nickname: "",
        phone: "",
        name: "",
        type: 0,
        describe: "",
        imageface: "",
        imageback: "",
        company_photo: ""
      };
      this.imagefacethumblist = [];
      this.imagebackthumblist = [];
      this.thumblist = [];

      this.$refs["agentsValidate"].resetFields();

      this.showModalStatus = !this.showModalStatus;
      this.agents.id = index;
      this.$api.partners.detail({ id: index }).then(res => {
        this.agents.id = res.result.partner_uuid;
        this.agents.name = res.result.name;
        this.agents.nickname = res.result.userdata.nickname;
        this.agents.phone = res.result.phone;
        this.agents.status = res.result.status;

        this.agents.describe = res.result.describe;
        let imgsArr =
          res.result.image == null ? [] : res.result.image.split(",");
        for (var i = 0; i < imgsArr.length; i++) {
          if (i == 0) {
            this.agents.imageface = res.result.image.split(",")[0];
            this.imagefacethumblist.push({
              name: res.result.image.split(",")[0],
              url: res.result.image.split(",")[0],
              status: "finished"
            });
          }
          if (i == 1) {
            this.agents.imageback = res.result.image.split(",")[1];
            this.imagebackthumblist.push({
              name: res.result.image.split(",")[1],
              url: res.result.image.split(",")[1],
              status: "finished"
            });
          }
        }
        this.agents.company_photo = res.result.company_photo;
        this.thumblist.push({
          name: res.result.company_photo,
          url: res.result.company_photo,
          status: "finished"
        });
      });
    },
    // 修改
    editagent (name) {
      if (this.$refs["imagefaceuploadthumb"].uploadList.length > 0) {
        this.agents.imageface = this.$refs[
          "imagefaceuploadthumb"
        ].uploadList[0].url;
      } else {
        this.agents.imageface = "";
      }
      if (this.$refs["imagebackuploadthumb"].uploadList.length > 0) {
        this.agents.imageback = this.$refs[
          "imagebackuploadthumb"
        ].uploadList[0].url;
      } else {
        this.agents.imageback = "";
      }
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        this.agents.company_photo = this.$refs["uploadthumb"].uploadList[0].url;
      } else {
        this.agents.company_photo = "";
      }
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {};
          params.id = this.agents.id; //是	string	代理商户UUID
          params.type = this.agents.type; //是	int	商户类型1导游2民宿3景点
          params.name = this.agents.name; //否	string	姓名
          params.describe = this.agents.describe; //否	string	简介
          params.status = this.agents.status;
          params.image = this.agents.imageface + "," + this.agents.imageback; //否	string	身份证正反图集
          params.company_photo = this.agents.company_photo; //否	string	营业执照
          this.$api.partners.edit(params).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showModalStatus = !this.showModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 去代理商户列表
    goagentlist (id) {
      this.$router.push("/partners/agent/" + id);
    },
    // 去商户列表
    gotradesmanlist (id) {
      this.$router.push("/partners/tradesman/" + id);
    },
    // 去代理商户提成记录
    gotcrecord (id) {
      this.$router.push("/partners/tc_record/" + id);
    },
    // 删除
    remove: function (uuid, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.partners.remove({ uuid: uuid, id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    change () { },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.status
      };
      this.$api.partners.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          for (var i in this.tablelist) {
            this.tablelist[i].phone = this.tablelist[i].data.phone;
            this.tablelist[i].auth_company = this.tablelist[
              i
            ].data.auth_company;
            this.tablelist[i].is_undeline =
              this.tablelist[i].is_undeline == 0 ? "否" : "是";
            this.tablelist[i].cate = this.tablelist[i].cate.name;
          }
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
